import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4934fe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brush-map" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p class=\"description-tools__item\" data-v-d4934fe8><svg width=\"3\" height=\"35\" viewBox=\"0 0 3 35\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-d4934fe8><path d=\"M1.1582 35.1436L1.17462 1.37673\" stroke=\"#b3b3b3\" stroke-width=\"1.70823\" stroke-linecap=\"round\" stroke-dasharray=\"0.85 2.56\" data-v-d4934fe8></path></svg><span data-v-d4934fe8>— зубная нить</span></p><p class=\"description-tools__item\" data-v-d4934fe8><svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-d4934fe8><circle cx=\"5.27966\" cy=\"4.75818\" r=\"3.84352\" fill=\"white\" stroke=\"#ff0000\" stroke-width=\"1.70823\" data-v-d4934fe8></circle></svg><span data-v-d4934fe8>— кровоточивость</span></p>", 2)
const _hoisted_4 = [
  _hoisted_2
]
const _hoisted_5 = {
  key: 0,
  class: "brush-map__buttons"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 5. Сохранить ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 5. Изменить ")

import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { showErrorMessage } from '@/shared/utils'
import { brushReportApi } from '@/shared/api/report/brushReport.api'
import { organizationsApi, patientApi, userApi } from '@/shared/api'
import { BrushMapTeeth } from '@/pages/BrushMapPage/brushMapTeeth'
import { WReportHeader } from '@/widgets/WReportHeader'
import { WReportSubmit } from '@/widgets/WReportSubmit'
import { WReportPrint } from '@/widgets/WReportPrint'
import { WSendToBot } from '@/widgets/WSendToBot'
import BrushMapHeader from './components/BrushMapHeader.vue'
import BrushMapAside from '@/pages/BrushMapPage/components/BrushMapAside/BrushMapAside.vue'
import BrushMapContent from './components/BrushMapContent.vue'
import BrushMapPreview from './components/BrushMapPreview.vue'
import BrushMapDialog from './components/BrushMapDialog.vue'
import BrushMapQr from './components/BrushMapQr.vue'
import { Tooth } from '@/pages/BrushMapPage/tooth'
import { BrushMapAddedBrushes } from '@/pages/BrushMapPage/brushMapAddedBrushes'
import { BrushToothResponseType } from '@/shared/types'
import { ElMessage } from 'element-plus'
import { BrushMapFirm } from './brushMapFirm'
import { BrushMapController } from './brushMapController'
import { UnionReportType } from '@/widgets/WReportHeader/types/union.type'
import { useReportListing } from '@/shared/composables'
import { REPORT_VIEW } from '@/shared/constants'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const { setUpdateReportListing } = useReportListing()

const reportId = computed(() => Number(route.params.reportId))
const patientId = computed(() => Number(route.params.patientId))
const reportInfo = ref<UnionReportType>({
  id: reportId.value,
  date_at: '',
  doctor: undefined,
  organization: undefined,
})
const qrCodeEnabled = computed(
  () =>
    reportInfo.value.organization?.qr_codes_enabled &&
    reportInfo.value.organization?.telegram_enabled &&
    maxEnabled.value
)

const maxEnabled = computed(() => process.env.VUE_APP_MAX_ENABLE === 'true')
const maxSendEnabled = computed(
  () => process.env.VUE_APP_UI_MAX_BLOCK_ENABLE === 'true'
)

const isCreationPage = computed(() => route.params.reportId === '0')
const isPreviewMode = computed(() => route.query['view-mode'] === '1')
const isModalVisible = ref(false)
const isModalQr = ref(false)
const isDentalFlossMode = ref(false)
const isSendedReport = ref(false)
const isLinkedPatient = ref(false)
const loading = ref(false)
const email = ref('')

const brushMapTeeth = reactive(new BrushMapTeeth())
const brushMapBrushes = reactive(new BrushMapAddedBrushes())
const brushMapFirm = reactive(new BrushMapFirm())
const brushMapController = reactive(new BrushMapController())

const resetValues = () => {
  brushMapTeeth.initTeeth()
  brushMapBrushes.clearBrushes()
  brushMapFirm.initFirm()
}

const initBrushMapController = () => {
  brushMapController.initiateBrushes()
  brushMapController.brushMapTeeth = brushMapTeeth
  brushMapController.brushMapAddedBrushes = brushMapBrushes
  brushMapController.brushMapFirm = brushMapFirm
}

const getUserInfo = async (userId: number) => {
  const [error, response] = await userApi.getUser(userId)

  if (error) {
    showErrorMessage(error)
  } else {
    reportInfo.value.doctor = response.data.user
  }
}

const getOrganizationInfo = async (organizationId: number) => {
  const [error, response] = await organizationsApi.getOrganizationInfo(
    organizationId
  )

  if (error) {
    showErrorMessage(error)
  } else {
    reportInfo.value.organization = response.data.organization
  }
}

const sendReport = async () => {
  loading.value = true

  const report = {
    firstGroupColors: brushMapBrushes.firstGroupBrushes,
    secondGroupColors: brushMapBrushes.secondGroupBrushes,
    teeth: brushMapTeeth.getTeethForSend(),
    brushesFirm: brushMapFirm.firm,
  }

  const [error, response] = await brushReportApi.saveReport(
    patientId.value,
    report
  )

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      type: 'success',
      message: 'Отчёт успешно создан',
    })

    if (!reportId.value) {
      setUpdateReportListing(true)

      await router.push({
        name: 'BrushMapPage',
        params: {
          patientId: patientId.value,
          reportId: response.data.id,
        },
      })
    }

    isModalQr.value = true
    loading.value = false
  }
}

const updateReport = async () => {
  loading.value = true

  const report = {
    firstGroupColors: brushMapBrushes.firstGroupBrushes,
    secondGroupColors: brushMapBrushes.secondGroupBrushes,
    teeth: brushMapTeeth.getTeethForSend(),
    brushesFirm: brushMapFirm.firm,
  }

  const [error, _] = await brushReportApi.updateReport(reportId.value, report)

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      type: 'success',
      message: 'Отчёт успешно обновлён',
    })

    isModalQr.value = true
    loading.value = false
  }
}

const proccessTooth = (tooth: BrushToothResponseType, index: number) => {
  const proccessedTooth = new Tooth(
    tooth.id,
    index,
    tooth.baseColor,
    tooth.arrowStatus,
    tooth.arrowColor,
    tooth.statusTooth,
    tooth.isDentalFloss,
    tooth.isBleeding
  )
  return proccessedTooth
}

const getFullReport = async () => {
  if (!reportId.value) return

  loading.value = true

  const [error, response] = await brushReportApi.getReport(reportId.value)

  if (error) {
    showErrorMessage(error)
  } else {
    const {
      user_id,
      organization_id,
      teeth,
      brushesFirm,
      firstGroupColors,
      secondGroupColors,
    } = response.data
    const proccessedTeeth: Tooth[] = teeth.map(proccessTooth)

    brushMapTeeth.teeth = proccessedTeeth
    brushMapFirm.firm = brushesFirm
    brushMapBrushes.clearBrushes()
    brushMapBrushes.setBrushes(firstGroupColors, secondGroupColors)
    console.log(response.data)
    isLinkedPatient.value = response.data.patient.sent_to_bot === 1
    isSendedReport.value = response.data.report_sent_to_bot

    initBrushMapController()
    brushMapController.setMapAddedBrushes()
    Promise.all([
      getUserInfo(user_id),
      getOrganizationInfo(organization_id),
      getPatientEmail(),
    ])
  }

  loading.value = false
}

const getPatientEmail = async (): Promise<void> => {
  const [error, response] = await patientApi.getPatientInfo(
    Number(patientId.value)
  )

  if (error) {
    showErrorMessage(error)
  } else {
    email.value = response.data.patient.email
  }
}

watch(reportId, (newReportId) => {
  if (route.name !== 'BrushMapPage') {
    return
  }

  if (route.name === 'BrushMapPage' && newReportId) {
    getFullReport()
    return
  }

  resetValues()
  initBrushMapController()
})

onMounted(() => {
  if (reportId.value) {
    getFullReport()
    return
  }

  resetValues()
  initBrushMapController()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(
        _unref(isPreviewMode) ? 'brush-map__container__nogap' : 'brush-map__container'
      )
      }, [
        (!_unref(isCreationPage))
          ? (_openBlock(), _createBlock(_unref(WReportHeader), {
              key: 0,
              "report-info": reportInfo.value,
              "report-type": _unref(REPORT_VIEW).brushMap
            }, null, 8, ["report-info", "report-type"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass([{ 'brush-map__block_preview': _unref(isPreviewMode) }, "brush-map__block"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass({ 'brush-map__flex': !_unref(isPreviewMode) })
          }, [
            _createVNode(BrushMapHeader, {
              brushMapFirm: _unref(brushMapFirm),
              onChangeDentalFlossMode: _cache[0] || (_cache[0] = ($event: any) => (isDentalFlossMode.value = $event)),
              onOpenTipWindow: _cache[1] || (_cache[1] = ($event: any) => (isModalVisible.value = true))
            }, null, 8, ["brushMapFirm"]),
            _createElementVNode("div", {
              class: _normalizeClass([{ 'brush-map__content_preview': _unref(isPreviewMode) }, "brush-map__content"])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([{ 'brush-map__wrapper_preview': _unref(isPreviewMode) }, "brush-map__wrapper"])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["description-tools", { 'description-tools_preview': _unref(isPreviewMode) }])
                }, _hoisted_4, 2),
                _createVNode(BrushMapContent, {
                  "brush-map-teeth": _unref(brushMapTeeth),
                  "brush-map-brushes": _unref(brushMapBrushes),
                  "brush-map-controller": _unref(brushMapController),
                  "is-dental-floss-mode": isDentalFlossMode.value,
                  "qr-code-enabled": _unref(qrCodeEnabled)
                }, null, 8, ["brush-map-teeth", "brush-map-brushes", "brush-map-controller", "is-dental-floss-mode", "qr-code-enabled"])
              ], 2),
              _createVNode(BrushMapAside, {
                "brush-map-controller": _unref(brushMapController),
                "brush-map-teeth": _unref(brushMapTeeth),
                "brush-map-brushes": _unref(brushMapBrushes),
                "brush-map-firm": _unref(brushMapFirm),
                onSendReport: sendReport,
                onUpdateReport: updateReport
              }, null, 8, ["brush-map-controller", "brush-map-teeth", "brush-map-brushes", "brush-map-firm"])
            ], 2)
          ], 2),
          (!_unref(isPreviewMode))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_unref(isCreationPage))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      round: "",
                      type: "primary",
                      onClick: sendReport
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      round: "",
                      type: "primary",
                      onClick: updateReport
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }))
              ]))
            : _createCommentVNode("", true)
        ], 2),
        (_unref(isPreviewMode))
          ? (_openBlock(), _createBlock(BrushMapPreview, { key: 1 }))
          : _createCommentVNode("", true),
        (_unref(isPreviewMode))
          ? (_openBlock(), _createBlock(_unref(WReportHeader), {
              key: 2,
              position: "bottom",
              "report-info": reportInfo.value,
              "report-type": _unref(REPORT_VIEW).brushMap
            }, null, 8, ["report-info", "report-type"]))
          : _createCommentVNode("", true),
        (!_unref(isPreviewMode))
          ? (_openBlock(), _createBlock(_unref(WReportSubmit), {
              key: 3,
              "report-type": _unref(REPORT_VIEW).brushMap,
              email: email.value,
              "hide-comment-files-checkbox": true
            }, null, 8, ["report-type", "email"]))
          : _createCommentVNode("", true),
        (!_unref(isPreviewMode))
          ? (_openBlock(), _createBlock(_unref(WReportPrint), {
              key: 4,
              "url-part": 'brush-maps'
            }))
          : _createCommentVNode("", true),
        (_unref(maxEnabled) && _unref(maxSendEnabled))
          ? (_openBlock(), _createBlock(_unref(WSendToBot), {
              key: 5,
              onUpdateSendedStatus: _cache[2] || (_cache[2] = ($event: any) => (isSendedReport.value = true)),
              onUpdateLinkedStatus: _cache[3] || (_cache[3] = ($event: any) => (isLinkedPatient.value = true)),
              reportName: "brushMap",
              "is-sended": isSendedReport.value,
              "is-linked": isLinkedPatient.value
            }, null, 8, ["is-sended", "is-linked"]))
          : _createCommentVNode("", true)
      ], 2)
    ])), [
      [
        _directive_loading,
        loading.value,
        void 0,
        { body: true }
      ]
    ]),
    _createVNode(BrushMapDialog, {
      "is-modal-visible": isModalVisible.value,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (isModalVisible.value = false))
    }, null, 8, ["is-modal-visible"])
  ], 64))
}
}

})